import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getZones, getHotels, getVehicles, getExcursions, getTestimonials, getRoutePrices } from '../lib/api';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [zones, setZones] = useState([]);
  const [airports, setAirports] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [excursions, setExcursions] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [routePrices, setRoutePrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [heroPreFill, setHeroPreFill] = useState(null);

  const loadData = useCallback(async () => {
    try {
      const [zonesRes, hotelsRes, vehiclesRes, excursionsRes, testimonialsRes, routesRes] = await Promise.all([
        getZones(true),
        getHotels(null, true),
        getVehicles(true),
        getExcursions(true),
        getTestimonials(true),
        getRoutePrices()
      ]);
      const allZones = zonesRes.data;
      setZones(allZones);
      setAirports(allZones.filter(z => z.zone_type === 'airport' || z.zone_type === 'port'));
      setDestinations(allZones.filter(z => z.zone_type === 'destination'));
      setHotels(hotelsRes.data);
      setVehicles(vehiclesRes.data);
      setExcursions(excursionsRes.data);
      setTestimonials(testimonialsRes.data);
      setRoutePrices(routesRes.data);
    } catch (error) {
      console.error('Error loading app data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadData(); }, [loadData]);

  return (
    <DataContext.Provider value={{
      zones, airports, destinations, hotels, vehicles, excursions, testimonials, routePrices,
      loading, refresh: loadData, heroPreFill, setHeroPreFill
    }}>
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error('useData must be used within DataProvider');
  return ctx;
}
